import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Tool from './Tool';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {withStyles} from '@material-ui/core/styles';
import {blue} from '@material-ui/core/colors';
import './collapse.css';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import {ControlledMenu, MenuItem} from '../../react-menu/dist'

type Props = {
    description: string,
    title: string,
    tools: [],
    collapse: boolean
};
type State = {
    collapse: boolean
};
const btnMenuItemClass = ' text-gray-600  hover:bg-blue-50    ';
const PurpleSwitch = withStyles({
    root: {
        marginLeft: '18px'
    },
    switchBase: {
        color: blue[50],
        '&$checked': {
            color: blue[200]
        },
        '&$checked + $track': {
            backgroundColor: blue[200]
        },
    },
    checked: {},
    track: {},
})(Switch);

class Panel extends React.Component<Props, State> {
    GridSizeInput = React.createRef();
    state = {
        collapse: false,
        EditorProps: {
            ...this.props.EditorProps,
            ContextMenuState: 'closed',
            anchorPoint: {x: 0, y: 0},
        }
    };
    componentDidMount = () => {
        const {collapse, EditorProps} = this.props;
        this.setState({
            collapse,
        });
    };

    onChangeShowRuler() {
        const {EditorPropsChange} = this.props;
        this.setState({
            ...this.state,
            EditorProps: {...this.state.EditorProps, ShowRuler: !this.state.EditorProps.ShowRuler}
        }, () => {
            EditorPropsChange(this.state.EditorProps);
        });
    }

    onChangeShowGridLines() {
        const {EditorPropsChange} = this.props;
        this.setState({
            ...this.state,
            EditorProps: {...this.state.EditorProps, ShowGridLines: !this.state.EditorProps.ShowGridLines}
        }, () => {
            EditorPropsChange(this.state.EditorProps);
        });
    }

    onChangeShowPageNumber() {
        const {EditorPropsChange} = this.props;
        this.setState({
            ...this.state,
            EditorProps: {...this.state.EditorProps, ShowPageNumber: !this.state.EditorProps.ShowPageNumber}
        }, () => {
            EditorPropsChange(this.state.EditorProps);
        });
    }

    onChangeGridSize(e) {
        const {EditorPropsChange} = this.props;
        this.setState({
            ...this.state,
            EditorProps: {...this.state.EditorProps, GridSize: e.target.value}
        }, () => {
            EditorPropsChange(this.state.EditorProps);
        });
    }

    toggle = () => {
        this.setState(state => ({
            collapse: !state.collapse
        }));
    };
    render = () => {
        const {title, description, tools, minWidth, maxWidth, classes, EditorProps, Pages} = this.props;
        const {collapse} = this.state;
        return (
            <div
            >
                <ControlledMenu
                    anchorPoint={this.state.anchorPoint}
                    state={this.state.ContextMenuState}
                    onMouseDown={e => e.stopPropagation()}
                    onMouseLeave={() => this.setState({ContextMenuState: 'closed'})}
                    transition={true}
                >
                    <MenuItem className={btnMenuItemClass}
                              styles={{
                                  color: 'gray',
                                  backgroundColor: 'white',
                                  hover: {
                                      color: 'gray',
                                      backgroundColor: 'white'
                                  },
                                  active: {
                                      color: 'gray',
                                      backgroundColor: 'white'
                                  }
                              }}
                    >
                        <React.Fragment>
                            <span style={{fontFamily: 'Raleway, Arial', fontSize: "12px"}}>Grid Size</span>
                            &nbsp;&nbsp;&nbsp;
                            <Box sx={{width: 120}}>
                                <Slider
                                    defaultValue={this.state.EditorProps.GridSize}
                                    step={1}
                                    valueLabelDisplay="auto"
                                    onChange={e => this.onChangeGridSize(e)}
                                    marks
                                    max={9}
                                    min={1}
                                    size={'small'}
                                    style={{width: '100px'}}
                                />
                            </Box>
                        </React.Fragment>
                    </MenuItem>
                </ControlledMenu>
                <div className="rounded-lg border border-grey-light bg-white mb-3 w-full  "
                     style={{maxWidth: maxWidth}}
                >
                    <button
                        type="button"
                        className="m-1 collapse-handler p-3 font-medium  bg-white"
                    >
                        {title}
                    </button>
                    <ReactCSSTransitionGroup
                        transitionName="fade"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}
                    >
                        {collapse === false ? null : (
                            <div className="border-t border-gray-200 ">
                                {description ? (
                                    <p className="p-2  border-b border-gray-200 text-gray-400  font-extralight"
                                       style={{fontSize: '0.9em'}}>{description}</p>
                                ) : null}
                                {tools &&
                                    tools.map((tool, i) => (
                                        <Tool
                                            key={i}
                                            icon={tool.icon}
                                            properties={tool.properties}
                                            type={tool.type}
                                            title={tool.title}
                                        />
                                    ))}
                            </div>
                        )}
                    </ReactCSSTransitionGroup>
                </div>
                <div className="rounded-lg border border-grey-light bg-white mt-1 w-full p-1 pt-2   "
                     style={{backgroundColor: 'red'}}
                >
                    <FormGroup
                        onContextMenu={e => {
                            if (!this.state.EditorProps.ShowGridLines) return;
                            e.preventDefault();
                            this.setState(
                                {
                                    anchorPoint: {
                                        x: e.clientX - 18,
                                        y: e.clientY - 26
                                    },
                                    ContextMenuState: 'opening'
                                },
                                () => {
                                    setTimeout(() => {
                                        try {
                                        } catch {
                                        }
                                        ;
                                    }, 1);
                                });
                        }}
                    >
                        <FormControlLabel
                            control=
                                {
                                    <PurpleSwitch
                                        size="small"
                                        checked={this.state.EditorProps.ShowRuler}
                                        onChange={e => this.onChangeShowRuler(e)}
                                        name="ShowRuler"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                        edge={'start'}
                                    />
                                }
                            label={
                                <span style={{fontFamily: 'Raleway, Arial', fontSize: "12px"}}>Ruler</span>
                            }
                        />
                        <FormControlLabel
                            control=
                                {
                                    <PurpleSwitch
                                        size="small"
                                        checked={this.state.EditorProps.ShowGridLines}
                                        onChange={e => this.onChangeShowGridLines(e)}
                                        name="ShowGridLines"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                        edge={'start'}
                                    />
                                }
                            label={
                                <React.Fragment>
                                    <span style={{fontFamily: 'Raleway, Arial', fontSize: "12px"}}>Grid Lines</span>
                                </React.Fragment>
                            }
                        />
                        {Pages.length > 1 && <FormControlLabel
                            control=
                                {
                                    <PurpleSwitch
                                        size="small"
                                        checked={this.state.EditorProps.ShowPageNumber}
                                        onChange={e => this.onChangeShowPageNumber(e)}
                                        name="ShowPageNumber"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                        edge={'start'}
                                    />
                                }
                            label={
                                <span style={{fontFamily: 'Raleway, Arial', fontSize: "12px", whiteSpace: 'nowrap'}}>Page Number</span>
                            }
                        />}
                    </FormGroup>
                </div>
            </div>
        );
    };
}

export default Panel;
